/**
 * AUTO-GENERATED from schema.json — DO NOT EDIT
 * Source: Testimonials (testimonials)
 * Run `yarn workspace @library/cms-blocks cms:types` to regenerate
 */

import { z } from 'zod'

export const TestimonialsFieldsSchema = z
  .object({
    heading: z.string(),
    testimonials: z.array(z.object({ quote: z.string(), author: z.string() }).passthrough()),
  })
  .passthrough()
